<template>
  <div class="modal fade" tabindex="-1" :id="id">
      <div class="modal-dialog modal-lg">
        <form id="kt_modal_form_other" @submit.prevent="updateOther" class="form mt-5" >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('other.edit') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor"/>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor"/>
                  </svg>
                </span>
              </div>
            </div>
            <OtherForm :id="id" :form-data="formData"/>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script setup>

import { defineProps,ref, watch } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import OtherForm from './OtherForm.vue';

const props = defineProps({
  formEdit:{
      type:Object,
      default:{}
  },
  id:{type: String, default:"create_modal"}
})

const store = useStore()

const formData = ref(props.formEdit)

watch(() => props.formEdit, (value) => {
    formData.value = props.formEdit
}, { deep: true })


const isLoading = ref(false)

const emit = defineEmits(['reloadDatatable'])


function closeModal(){
$('#'+props.id).modal('toggle')
}

async function updateOther() {
  isLoading.value = true
  try{
    await store.dispatch('others/updateOther', formData.value)
    window.toastr.success(i18n.global.t("notification.other_updated"))
    emit('reloadDatatable')
    formData.value={
      title: '',
      society_id: "c46ed830-eeed-4668-88a5-eea7d809f4c2",
      other_data : [
          {
              type: 'amount',
              amount: 0,
             range_min: 0,
              range_max: ''
          }
      ],
    }
    isLoading.value = false
    $('#'+props.id).modal('toggle')
  }catch(err){
    isLoading.value = false
  }
}

</script>
